import { EuiBadge } from "@inscopix/ideas-eui";
import { colorsByRunStatus } from "types/ColorsByRunStatus";
import { RunStatus } from "types/constants";

interface RunStatusBadgeProps {
  runStatus: RunStatus;
}

export const RunStatusBadge = ({ runStatus }: RunStatusBadgeProps) => {
  const color = colorsByRunStatus[runStatus];
  const runStatusName = RunStatus[runStatus];
  return <EuiBadge color={color}>{runStatusName}</EuiBadge>;
};
